import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as EmptyActionMetadataKeys from 'automation-ui-action-features/actions/empty-action/EmptyActionMetadataKeys';
export default class EmptyActionMetadata extends Record({
  [EmptyActionMetadataKeys.ACTION_TYPE]: ActionTypes.EMPTY_ACTION
}, 'EmptyActionMetadata') {}